<template>
    <div class="content-wrapper-scroll">
        <div class="content-wrapper">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-header">
                            <h5>Holidays</h5>
                        </div>
                        <div class="card-body">
                            <div class="col-sm-12">

                                <div class="input-group">

                                    <input class="form-control" type="text"
                                        placeholder="Type here and press enter to search" v-model="meta.search"
                                        @keyup.enter="search">
                                    <span class="input-group-text">
                                        <i class="fas fa-search"></i>
                                    </span>

                                </div>
                                <br />
                            </div>
                            <div class="table-responsive tabletop">
                                <table class="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th @click="sort('plant_name')">
                                                Plant
                                                <span>
                                                    <i v-if="meta.field == 'plant_name' && meta.order_by == 'asc'"
                                                        class="fas fa-sort-up"></i>
                                                    <i v-else-if="meta.field == 'plant_name' && meta.order_by == 'desc'"
                                                        class="fas fa-sort-down"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                                </span>
                                            </th>
                                            <th @click="sort('name')">
                                                Name
                                                <span>
                                                    <i v-if="meta.field == 'name' && meta.order_by == 'asc'"
                                                        class="fas fa-sort-up"></i>
                                                    <i v-else-if="meta.field == 'name' && meta.order_by == 'desc'"
                                                        class="fas fa-sort-down"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                                </span>
                                            </th>
                                            <th>
                                                Department
                                            </th>
                                            <th>
                                                From Date
                                            </th>
                                            <th>
                                                To Date
                                            </th>
                                            <th>
                                                No. of Days
                                            </th>
                                            <th>
                                                Note
                                            </th>                                            
                                            <th class="text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="holidays.length == 0">
                                            <td colspan="9" class="text-center">No records found</td>
                                        </tr>
                                        <tr v-for="(holiday, key) in holidays" :key="key">
                                            <td>{{ meta.from + key }}</td>
                                            <td>{{ getHolidayPlantName(holiday) }}</td>
                                            <td>{{ getHolidayUserName(holiday) }}</td>
                                            <td>{{ getHolidayDepartmentName(holiday) }}</td>
                                            <td>{{ holiday.from_date }}</td>
                                            <td>{{ holiday.to_date }}</td>
                                            <td>{{ holiday.days }}</td>
                                            <td>{{ holiday.note }}</td>
                                            <td class="td-actions">
                                                <a href="#" class="icon blue me-2"
                                                    @click.prevent="viewHolidayTemplates(holiday)">
                                                    <i class="fas fa-eye"></i>
                                                </a>
                                                <a href="#" v-can="'users.delete'" class="icon red"
                                                    @click.prevent="deleteRow(holiday)">
                                                    <i class="icon-cancel"></i>
                                                </a>    
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="form-actions-footer">
                                <div class="text-end row">
                                    <div class="col-sm-2">
                                        <select class="form-control" v-model="meta.per_page" @change="onPerPageChange">
                                            <option>10</option>
                                            <option>15</option>
                                            <option>20</option>
                                            <option>25</option>
                                            <option>30</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-10">
                                        <Pagination class="pagination pagination-sm" :maxPage="meta.maxPage"
                                            :totalPages="meta.lastPage" :currentPage="meta.currentPage"
                                            @pagechanged="onPageChange" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Holiday Templates Modal -->
        <div class="modal fade" id="holidayTemplatesModal" tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Holiday Templates</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="selectedHoliday" class="mb-3">
                            <div class="row">
                                <div class="col-md-6">
                                    <p><strong>User:</strong> {{ getSelectedHolidayUserName() }}</p>
                                    <p><strong>Plant:</strong> {{ getSelectedHolidayPlantName() }}</p>
                                    <p><strong>Department:</strong> {{ getSelectedHolidayDepartmentName() }}</p>
                                </div>
                                <div class="col-md-6">
                                    <p><strong>From Date:</strong> {{ selectedHoliday.from_date }}</p>
                                    <p><strong>To Date:</strong> {{ selectedHoliday.to_date }}</p>
                                    <p><strong>Days:</strong> {{ selectedHoliday.days }}</p>
                                    <p><strong>Note:</strong> {{ selectedHoliday.note }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-bordered table-striped">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Template Name</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="selectedHolidayTemplates.length === 0">
                                        <td colspan="6" class="text-center">No templates found</td>
                                    </tr>
                                    <tr v-for="(template, key) in selectedHolidayTemplates" :key="key">
                                        <td>{{ key + 1 }}</td>
                                        <td>{{ getTemplateName(template) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Pagination from "@/components/Pagination.vue";
export default {
    components: { Pagination },
    data() {
        return {
            status: true,
            errors: [],
            holidays: [],
            selectedHoliday: null,
            meta: {
                search: "",
                order_by: "asc",
                field: "name",
                user_id: this.$store.getters.user.user_id,
                per_page: 10,
                totalRows: 0,
                currentPage: 1,
                lastPage: 1,
                from: 1,
                maxPage: 1,
                plant_id: this.$store.getters.user.plant_id,
            },
        };
    },
    computed: {
        selectedHolidayTemplates() {
            if (!this.selectedHoliday) {
                return [];
            }
            if (!this.selectedHoliday.holiday_templates) {
                return [];
            }
            return this.selectedHoliday.holiday_templates;
        },
    },
    mounted() {
        let vm = this;
        vm.index();
    },
    methods: {
        index() {
            let vm = this;
            let loader = vm.$loading.show();            
            let uri = 'paginateHolidays?page=' + vm.meta.currentPage + '&search=' + vm.meta.search + '&order_by=' + vm.meta.order_by + '&field=' + vm.meta.field + '&per_page=' + vm.meta.per_page + '&user_id=' + vm.meta.user_id+ '&plant_id=' + vm.meta.plant_id;
            vm.$store.dispatch('post', { 'uri': uri })
                .then(function (response) {
                    vm.holidays = response.data.data;
                    loader.hide();
                    vm.meta.totalRows = response.data.meta.total;
                    vm.meta.lastPage = response.data.meta.last_page;
                    vm.meta.from = response.data.meta.from;
                    if (vm.meta.lastPage >= 3) {
                        vm.meta.maxPage = 3;
                    } else {
                        vm.meta.maxPage = vm.meta.lastPage;
                    }
                })
                .catch(function (error) {
                    loader.hide();
                    if (error.response) {
                        if (error.response.data) {
                            if (error.response.data.errors) {
                                vm.errors = error.response.data.errors;
                            }
                            if (error.response.data.message) {
                                vm.$store.dispatch('error', error.response.data.message);
                            }
                        }
                    }
                });
        },

        deleteRow(holiday) {
            let vm = this;
            if (confirm("Do you want to delete this entry?")) {
                let loader = vm.$loading.show();
                vm.$store.dispatch("post", { uri: "deleteHoliday", data: {holiday_id: holiday.holiday_id} })
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("success", "Holiday is successfully deleted!");
                        vm.index();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            }
        },

        onPageChange(page) {
            this.meta.currentPage = page;
            this.index();
        },

        onPerPageChange() {
            this.meta.currentPage = 1;
            this.index();
        },
        sort(field) {
            this.meta.field = field;
            if (this.meta.order_by == 'asc') {
                this.meta.order_by = 'desc';
            } else {
                this.meta.order_by = 'asc';
            }
            this.index();
        },
        search() {
            let vm = this;
            vm.meta.currentPage = 1;
            vm.index();
        },
        viewHolidayTemplates(holiday) {
            let vm = this;
            // Use holiday_templates from paginateHolidays response if available
            vm.selectedHoliday = holiday;
            // If holiday_templates doesn't exist, set it to empty array
            if (!vm.selectedHoliday.holiday_templates) {
                vm.selectedHoliday.holiday_templates = [];
            }
            vm.openHolidayModal();
        },
        openHolidayModal() {
            const modalEl = document.getElementById('holidayTemplatesModal');
            if (modalEl) {
                const bootstrap = window.bootstrap || window.Bootstrap;
                if (bootstrap && bootstrap.Modal) {
                    const modal = new bootstrap.Modal(modalEl);
                    modal.show();
                } else {
                    // Fallback
                    modalEl.classList.add('show');
                    modalEl.style.display = 'block';
                    document.body.classList.add('modal-open');
                }
            }
        },

        getHolidayPlantName(holiday) {
            if (!holiday) {
                return '';
            }
            if (!holiday.user) {
                return '';
            }
            if (!holiday.user.plant) {
                return '';
            }
            if (holiday.user.plant.plant_name) {
                return holiday.user.plant.plant_name;
            }
            return '';
        },

        getHolidayUserName(holiday) {
            if (!holiday) {
                return '';
            }
            if (!holiday.user) {
                return '';
            }
            if (holiday.user.name) {
                return holiday.user.name;
            }
            return '';
        },

        getHolidayDepartmentName(holiday) {
            if (!holiday) {
                return '';
            }
            if (!holiday.department) {
                return '';
            }
            if (holiday.department.department_name) {
                return holiday.department.department_name;
            }
            return '';
        },

        getSelectedHolidayUserName() {
            if (!this.selectedHoliday) {
                return '';
            }
            if (!this.selectedHoliday.user) {
                return '';
            }
            if (this.selectedHoliday.user.name) {
                return this.selectedHoliday.user.name;
            }
            return '';
        },

        getSelectedHolidayPlantName() {
            if (!this.selectedHoliday) {
                return '';
            }
            if (!this.selectedHoliday.user) {
                return '';
            }
            if (!this.selectedHoliday.user.plant) {
                return '';
            }
            if (this.selectedHoliday.user.plant.plant_name) {
                return this.selectedHoliday.user.plant.plant_name;
            }
            return '';
        },

        getSelectedHolidayDepartmentName() {
            if (!this.selectedHoliday) {
                return '';
            }
            if (!this.selectedHoliday.department) {
                return '';
            }
            if (this.selectedHoliday.department.department_name) {
                return this.selectedHoliday.department.department_name;
            }
            return '';
        },

        getTemplateName(template) {
            if (!template) {
                return '';
            }
            if (!template.template) {
                return '';
            }
            if (template.template.template_name) {
                return template.template.template_name;
            }
            return '';
        },
    },
};
</script>
